export const linkClassName =
  'text-primary-600 hover:text-primary-700 transition-colors duration-200 focus-visible:underline focus-visible:outline-none rounded-sm';
